import { render, staticRenderFns } from "./FlashTopicSelector.vue?vue&type=template&id=2c4dfc8e&scoped=true"
import script from "./FlashTopicSelector.vue?vue&type=script&lang=js"
export * from "./FlashTopicSelector.vue?vue&type=script&lang=js"
import style0 from "./FlashTopicSelector.vue?vue&type=style&index=0&id=2c4dfc8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4dfc8e",
  null
  
)

export default component.exports